// Wrapper function for slick that starts autoplay videos inside a slick slider.
// This gets around a bug where videos will not autoplay when the DOM changes around them.
function initializeSlick(element, slick_params, onInit) {
	var slider = $(element);
	slider.on('init', function(slick){
		slider.find('video').each(function() {
			$(this).get(0).play();
		});
		// setTimeout(function(){
		// 	slider.find('.slick-slide').each(function() {
		// 		$(this).removeAttr('tabindex');
		// 	});
		// }, 1000);
		if (onInit && typeof onInit !== 'undefined')
			onInit(slick);
	});
	slider.slick(slick_params);

	var interactedWithSlider = function(e) {
		slider.slick('slickPause');
	}
	slider.click(interactedWithSlider);
	slider.keyup(interactedWithSlider);
	return slider;
}